import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import { makeStyles, OutlinedInput } from "@material-ui/core";
import { Eye, EyeOff, Lock } from "lucide-react";

const useStyles = makeStyles((theme) => ({
  inputLabel: {
    color: "#0f1729 !important",
    paddingLeft: "0 !important",
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "4px",
  },
  input: {
    boxShadow:
      "0 0 #0000, 0 0 #0000, 0 0 #0000, 0 0 #0000, 0 1px 3px 0 #0000001a,0 1px 2px -1px #0000001a",
    background: "oklch(98.4% .003 247.858)",
    border: "1px solid oklch(92.9% .013 255.508)",
    "&.Mui-focused": {
      background: "#fff",
      outline: "hsl(45 93% 47%) solid 1px",
      "& input": {
        background: "#fff !important",
      },
    },
    "& input": {
      padding: "0px 0px 0px 12px",
      height: "36px",
      background: "oklch(98.4% .003 247.858) !important",

      border: "none !important",
    },
  },
  icon: {
    width: "16px",
    height: "16px",
    color: "oklch(70.4% .04 256.788)",
  },
  iconHover: {
    "&:hover": {
      color: "oklch(44.6% .043 257.281)",
    },
  },
  button: {
    border: "none",
    background: "transparent",
  },
}));

export default function MembershipPasswordComponent(props) {
  const {
    componentStyle = null,
    fullWidth = false,
    error,
    label,
    value,
    onChange,
    placeholder,
    helperText,
    showPassword: ancestorShowPassword = false,
    onShowPasswordClicked,
    // disableUnderline = false,
  } = props;

  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(ancestorShowPassword);
  const handleClickShowPassword = () => {
    setShowPassword((showPassword) => !showPassword);
    if (typeof onShowPasswordClicked === "function") {
      onShowPasswordClicked();
    }
  };

  useEffect(() => {
    if (ancestorShowPassword != null) {
      setShowPassword(ancestorShowPassword);
    }
  }, [ancestorShowPassword]);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <FormControl className={componentStyle} fullWidth={fullWidth} error={error}>
      {!!label && (
        <label className={classes.inputLabel} htmlFor="member-password">
          {label}
        </label>
      )}
      <OutlinedInput
        id="member-password"
        type={showPassword ? "text" : "password"}
        value={value || ""}
        disableUnderline
        onChange={(event) => {
          onChange(event.target.value);
        }}
        placeholder={placeholder}
        className={classes.input}
        startAdornment={
          <InputAdornment position="start">
            <Lock className={classes.icon} />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <button
              className={classes.button}
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? (
                <EyeOff className={`${classes.icon} ${classes.iconHover}`} />
              ) : (
                <Eye className={`${classes.icon} ${classes.iconHover}`} />
              )}
            </button>
          </InputAdornment>
        }
      />
      {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

MembershipPasswordComponent.propTypes = {
  componentStyle: PropTypes.any,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  showPassword: PropTypes.bool,
  onShowPasswordClicked: PropTypes.func,
};
